module.exports = __webpack_public_path__ + "media/images/pc/stores/kamakura/kamakura_concept_03-f66c52d76415b4d37400fae7d6b02a7a.jpg";